module.exports = __webpack_public_path__ + "img/a06a724f0d408eb77695d910cccb6478.png";